<template>
  <div class="profitability-indicator flex justify-between items-center mt-2 gap-6 px-3 py-1 bg-gray-800 rounded text-sm">
    <select
      id="period-select"
      v-model.number="internalSelectedPeriod"
      class="w-full p-1 text-[12px] rounded bg-gray-700 text-gray-100"
    >
      <option :value="0">All time</option>
      <option :value="1">1 Day</option>
      <option :value="7">1 Week</option>
      <option :value="30">1 Month</option>
    </select>

    <div class="profit-value w-full ">
      <div class="text-[12px]">
        <span class="text-gray-400"> Profitability: </span>
        <strong>
          {{ profitabilityData.profitPercent }}
          <span v-if="profitabilityData.profitPercent !== 'N/A'">%</span>
        </strong>
      </div>
      <div class="flex gap-2">
        <div class="text-green-500 text-[12px]">W <strong>{{ profitabilityData.wins }}</strong></div>
        <div class="text-red-500 text-[12px]">L <strong>{{ profitabilityData.losses }}</strong></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
  results:         { type: Array,    required: true },
  filter:          { type: Object,   required: true }, // { sport: string|null, league: string|null }
  selectedPeriod:  { type: Number,   required: true },
  mapSportToGroup: { type: Function, required: true }
});

const emit = defineEmits(['update:selectedPeriod']);
const internalSelectedPeriod = ref(props.selectedPeriod);

watch(() => props.selectedPeriod, val => {
  internalSelectedPeriod.value = val;
});
watch(internalSelectedPeriod, val => {
  emit('update:selectedPeriod', val);
});

const profitabilityData = computed(() => {
  const now = new Date();
  let periodStart = null;

  if (internalSelectedPeriod.value > 0) {
    periodStart = new Date(now);
    periodStart.setDate(now.getDate() - internalSelectedPeriod.value);
  }

  // Фильтрация по периоду, лиге или спорту
  const filtered = props.results.filter(match => {
    const matchDate = new Date(match.date);
    if (isNaN(matchDate)) return false;

    // период
    if (periodStart && matchDate < periodStart) return false;

    // лига
    if (props.filter.league) {
      if (match.league !== props.filter.league) return false;
    }
    // спорт
    else if (props.filter.sport) {
      const group = props.mapSportToGroup(match.sport);
      if (group !== props.filter.sport) return false;
    }

    return true;
  });

  if (filtered.length === 0) {
    return { wins: 0, losses: 0, profitPercent: 'N/A' };
  }

  let wins = 0, losses = 0, totalReturn = 0;
  for (const m of filtered) {
    if (m.betResult === 'won') {
      wins++;
      totalReturn += m.coefficient;
    } else if (m.betResult === 'lost') {
      losses++;
    }
  }

  const totalBets = wins + losses;
  const profitPercent = totalBets > 0
    ? ((totalReturn / totalBets - 1) * 100).toFixed(2)
    : 'N/A';

  return { wins, losses, profitPercent };
});
</script>
